import { createStore } from "vuex";
import { auth } from "./auth.module.js";
import { profile } from "./profile.module.js";
import { users } from './user.module';
import { projects } from "./projects.module.js";
import { models } from "./models.module.js";
import { budgets } from "./budget.module.js";
import { evidences } from "./evidences.module.js";
import { analitycs } from "./analitycs.module.js";
import { inventory } from "./inventory.modules.js";
import { purchases } from "./purchases.modules.js";
import { purchasesDetails } from "./purchasesDetails.modules.js";
import { purchasesPayments } from "./purchasesPayments.module.js";
import { modelsDetails } from "./modelsDetails.modules.js";
import { sizes } from "./sizes.modules.js";
import { production } from "./production.modules.js";
import { productionUsers } from "./productionUsers.modules.js";
import { productionDetails } from "./productionDetails.modules.js";
import { media } from "./media.modules.js";
import { bodegas } from "./bodegas.modules.js";
import { categories } from "./categories.module.js";
import { colors } from "./colors.module.js";
import { oficios } from "./oficios.module.js";
import { tallas } from "./tallas.modules.js";
import { productionModels } from "./productionModels.modules.js";
import { modelsModel } from "./modelsModel.modules.js";
import { settings } from "./settings.module.js";
import { payments } from "./payments.modules.js";
import { productionPayments } from "./productionPayments.modules.js";
import { optometryRecords } from "./optometryRecords.modules.js";
import { remissions } from "./remissions.module.js";
import { remissionsDetails } from "./remissionsDetails.module.js";
import { remissionsPayments } from "./remissionsPayments.module.js";
import { cashClosures } from "./cashClosures.modules.js";
import { workerTasks } from "./workerTasks.modules.js";
import { serviceOrders } from "./serviceOrders.module.js";
import { metrics } from "./metrics.module.js";
export default createStore({
  modules: {
    auth,
    profile,
    users, 
    projects, 
    budgets,
    evidences,
    analitycs,
    models,
    inventory,
    purchases,
    purchasesDetails,
    purchasesPayments,
    modelsDetails,
    sizes,
    production,
    productionUsers,
    productionModels,
    productionDetails,
    media,
    bodegas,
    categories,
    colors,
    oficios,
    tallas,
    modelsModel,
    settings,
    payments,
    productionPayments,
    optometryRecords,
    remissions,
    remissionsDetails,
    remissionsPayments,
    cashClosures,
    workerTasks,
    serviceOrders,
    metrics
  },
  state: {
    hideConfigButton: false,
    isPinned: false,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default"
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    /** Ajusta menú lateral: oculto en móvil/tablet (< 1200px), fijado en escritorio. */
    applySidenavBreakpoint(state) {
      if (typeof window === "undefined") {
        return;
      }
      const root = document.getElementById("app");
      if (!root || !root.classList.contains("g-sidenav-show")) {
        return;
      }
      const isDesktop = window.innerWidth >= 1200;
      if (isDesktop) {
        root.classList.remove("g-sidenav-hidden");
        root.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        root.classList.add("g-sidenav-hidden");
        root.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    /** Cierra el drawer del menú en móvil/tablet (< xl), mismo estado que al minimizar con la hamburguesa. */
    closeMobileSidenav(state) {
      if (typeof window === "undefined" || window.innerWidth >= 1200) {
        return;
      }
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (!sidenav_show) {
        return;
      }
      sidenav_show.classList.add("g-sidenav-hidden");
      sidenav_show.classList.remove("g-sidenav-pinned");
      state.isPinned = false;
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    applyRouteLayout(state, route) {
      const authLayout = route?.meta?.layout === "auth"
        || route?.matched?.some((record) => record.meta?.layout === "auth");
      const ticketLayout = route?.meta?.layout === "ticket"
        || route?.matched?.some((record) => record.meta?.layout === "ticket");
      const minimalLayout = authLayout || ticketLayout;
      state.showSidenav = !minimalLayout;
      state.showNavbar = !minimalLayout;
      state.showFooter = !minimalLayout;
      state.hideConfigButton = minimalLayout;
      if (typeof document !== "undefined") {
        const root = document.getElementById("app");
        if (authLayout) {
          document.body.classList.remove("bg-gray-100");
          root?.classList.add("auth-layout-active");
          root?.classList.remove("ticket-layout-active");
        } else if (ticketLayout) {
          document.body.classList.remove("bg-gray-100");
          root?.classList.remove("auth-layout-active");
          root?.classList.add("ticket-layout-active");
        } else {
          document.body.classList.add("bg-gray-100");
          root?.classList.remove("auth-layout-active");
          root?.classList.remove("ticket-layout-active");
        }
      }
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    }
  },
  getters: {}
});
